<template>
  <div class="layout-flex">
    <div class="layout-flex-item" @click="handleTabs('meb')">
      <img v-show="curIndex!=1" class="item-img" src="../../assets/meb/imgs/icon1@2x.png" />
      <img v-show="curIndex==1" class="item-img" src="../../assets/meb/imgs/icon1a@2x.png" />
    </div>
    <div class="layout-flex-item" @click="handleTabs('meb2')">
      <img v-show="curIndex!=2" class="item-img" src="../../assets/meb/imgs/icon2@2x.png" />
      <img v-show="curIndex==2" class="item-img" src="../../assets/meb/imgs/icon2a@2x.png" />
    </div>
    <div class="layout-flex-item" @click="handleTabs('meb3')">
      <img v-show="curIndex!=3" class="item-img" src="../../assets/meb/imgs/icon3@2x.png" />
      <img v-show="curIndex==3" class="item-img" src="../../assets/meb/imgs/icon3a@2x.png" />
    </div>
    <div class="layout-flex-item" @click="handleTabs('meb4')">
      <img v-show="curIndex!=4" class="item-img" src="../../assets/meb/imgs/icon4@2x.png" />
      <img v-show="curIndex==4" class="item-img" src="../../assets/meb/imgs/icon4a@2x.png" />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: ["index"],
  data() {
    return {
      curIndex: this.index
    };
  },
  mounted() {
    console.log(this);
  },
  methods: {
    handleTabs(val) {
      this.$router.push({ name: val });
    }
  }
};
</script>

<style lang="less" scoped>
.layout-flex {
  width: 1200px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  .layout-flex-item {
    margin-left: -30px;
    width: 277px;
    height: 53px;
  }
  .layout-flex-item:first-child {
    margin-left: 0px;
  }
  .item-img {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}
// @media screen and (min-width: 1600px) {
//   .layout-flex {
//     width: 1600px;
//     .layout-flex-item {
//       width: 359px;
//       height: 70px;
//     }
//   }
// }
</style>
